import { loadData } from '@/assets/js/cache.js'

const state = {
  user: {
  },
  windowScale: {
    w_scale: null,
    h_scale: null,
  },
  currentMenuId: 'planningAll',
  breadcrumbData: { data: [], show: true },
  showLeftMenu: true,
  permissions: [],
  unreadNumber: '',
  storage: loadData(),
  routerSelect: '',
}

export default state
